import { ReporterProvider } from '../contracts/ReporterProvider.js';

/**
 * Example Crashlytics Provider implementing ReporterProvider.
 * Demonstrates how easily Bugsnag can be replaced or accompanied by Crashlytics in the future.
 */
export class CrashlyticsProvider extends ReporterProvider {
  constructor() {
    super();
    this.name = 'crashlytics';
    this.isInitialized = false;
    this.client = null;
  }

  init(config) {
    // When migrating to Crashlytics / Firebase Analytics / etc.:
    // Initialize Firebase Crashlytics web instance here.
    this.config = config;
    this.isInitialized = true;
    return this;
  }

  notify(error, metadataOrOnError) {
    if (!this.isInitialized) return;
    // e.g. firebase.crashlytics().recordError(error)
  }

  setUser(user = {}) {
    if (!this.isInitialized) return;
    // e.g. firebase.crashlytics().setUserId(user.id)
  }

  clearUser() {
    if (!this.isInitialized) return;
  }

  addMetadata(section, data) {
    if (!this.isInitialized) return;
    // e.g. firebase.crashlytics().setCustomKeys(...)
  }

  clearMetadata(section, key) {
    if (!this.isInitialized) return;
  }

  leaveBreadcrumb(name, metadata, type) {
    if (!this.isInitialized) return;
    // e.g. firebase.crashlytics().log(name)
  }

  getClient() {
    return this.client;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/monitoring/providers/CrashlyticsProvider.js